export default "__VITE_ASSET__ba3ef854__"